import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  RadioGroup,
  Radio,
  Stack,
  Grid
} from '@chakra-ui/react'
import { FC, useEffect } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationSettings from '@hook/parametrization/use-settings'
import useFilters from '@hook/shared/use-filters'

import Filter from '@component/Shared/Filter'

const ParametrizationSettingsCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    paramsEdit,
    selected,
    handleUpdateEditParams,
    createData,
    handleUpdateYesModal,
    handleUpdateNotModal
  } = useParametrizationSettings()

  const { getFilters, profiles } = useFilters()

  useEffect(() => {
    getFilters({
      profiles: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const removedRadioButton = (id: string, value: any) => {
    handleUpdateEditParams({ name: id, value: value })
    // setCounter(counter + 1)
    // if (counter === 2) {
    //   handleUpdateEditParams({ name: id, value: '' })
    //   setCounter(0)
    //   setChange(false)
    // } else {
    //   if (change) {
    //     handleUpdateEditParams({ name: id, value: value })
    //   } else {
    //     setChange(true)
    //   }
    // }
  }

  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            bg="white"
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0
                  ? 'Editar Configuracao Abastecimento'
                  : 'Criar Configuracao Abastecimento'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <Flex>
              <FormControl isRequired>
                <Filter
                  label="Perfil"
                  options={profiles}
                  value={paramsEdit.idPerfil}
                  isDisabled={selected !== 0}
                  onChange={value =>
                    handleUpdateEditParams({ name: 'idPerfil', value: value })
                  }
                  // isLoading={loadingEdit}
                />
              </FormControl>
              <Box pt={3}>
                <Button
                  colorScheme="green"
                  m={4}
                  w="220px"
                  maxW="150px"
                  onClick={handleUpdateYesModal}
                >
                  Marcar todos Sim
                </Button>
              </Box>

              <Box pt={3}>
                <Button
                  m={4}
                  w="220px"
                  maxW="150px"
                  colorScheme="red"
                  onClick={handleUpdateNotModal}
                >
                  Marcar todos Não
                </Button>
              </Box>
            </Flex>

            <br></br>
            <Grid templateColumns="repeat(5, 1fr)" gap={6}>
              <FormControl isRequired>
                <FormLabel> Abastecer</FormLabel>
                <RadioGroup
                  onChange={value => removedRadioButton('abastercer', value)}
                  value={paramsEdit.abastercer}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Tipo de Suprimento</FormLabel>
                <RadioGroup
                  onChange={value =>
                    removedRadioButton('tipoSuprimento', value)
                  }
                  value={paramsEdit.tipoSuprimento}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>

              <FormControl isRequired>
                <FormLabel> Usar Politica de Estoque Otimizada</FormLabel>
                <RadioGroup
                  onChange={value =>
                    removedRadioButton('politicaEstoque', value)
                  }
                  value={paramsEdit.politicaEstoque}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Incluir Projeções de Venda</FormLabel>
                <RadioGroup
                  onChange={value =>
                    removedRadioButton('incluirPrevisaoLeadTime', value)
                  }
                  value={paramsEdit.incluirPrevisaoLeadTime}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Utilizar Estoque Minimo</FormLabel>
                <RadioGroup
                  onChange={value =>
                    removedRadioButton('utilizarEstoqueMinimo', value)
                  }
                  value={paramsEdit.utilizarEstoqueMinimo}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Grid>
            <br></br>

            <Grid pt={2} templateColumns="repeat(5, 1fr)" gap={6}>
              <FormControl isRequired>
                <FormLabel> EMax</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('maximo', value)}
                  value={paramsEdit.maximo}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Frequência de Pedidos </FormLabel>

                <RadioGroup
                  onChange={value =>
                    removedRadioButton('frequenciaDePedidos', value)
                  }
                  value={paramsEdit.frequenciaDePedidos}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Lead Time</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('leadTime', value)}
                  value={paramsEdit.leadTime}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Lote Múltiplo</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('loteMultiplo', value)}
                  value={paramsEdit.loteMultiplo}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Política de Estoque Arbitrária</FormLabel>

                <RadioGroup
                  onChange={value =>
                    removedRadioButton('politicaDeEstoqueArbitraria', value)
                  }
                  value={paramsEdit.politicaDeEstoqueArbitraria}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid pt={2} templateColumns="repeat(5, 1fr)" gap={6}>
              <FormControl isRequired>
                <FormLabel>Lote Mínimo CD</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('loteMinimoCD', value)}
                  value={paramsEdit.loteMinimoCD}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Estoque Arbitrado</FormLabel>

                <RadioGroup
                  onChange={value =>
                    removedRadioButton('estoqueArbitrado', value)
                  }
                  value={paramsEdit.estoqueArbitrado}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Estoque minimo</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('estoqueMinimo', value)}
                  value={paramsEdit.estoqueMinimo}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> CD de Origem</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('cdDeOrigem', value)}
                  value={paramsEdit.cdDeOrigem}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              {/* <FormControl isRequired>
                <FormLabel> Cluster Centro</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('clusterCentro', value)}
                  value={paramsEdit.clusterCentro}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
              <FormControl isRequired>
                <FormLabel> Cluster Produto</FormLabel>

                <RadioGroup
                  onChange={value =>
                    removedRadioButton('clusterProduto', value)
                  }
                  value={paramsEdit.clusterProduto}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl> */}
              {/* <FormControl isRequired>
                <FormLabel> Status</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('status', value)}
                  value={paramsEdit.status}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl> */}
              <FormControl isRequired>
                <FormLabel>Ponto de Pedido</FormLabel>

                <RadioGroup
                  onChange={value => removedRadioButton('pontoPedido', value)}
                  value={paramsEdit.pontoPedido}
                >
                  <Stack>
                    <Radio borderColor="black" value="1">
                      Sim
                    </Radio>
                    <Radio borderColor="black" value="2">
                      Não
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid pt={2} templateColumns="repeat(3, 1fr)" gap={6}></Grid>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  createData()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationSettingsCreate
